import React from 'react'
import './style.css'

const TableHeadRowStart = ({ text }) => {
  return (
    <th style={{ whiteSpace: "nowrap", paddingLeft: 10, paddingRight: 10, color: '#2d3635' }}>{text}</th>
  )
}

export default TableHeadRowStart